module.exports = __webpack_public_path__ + "static/media/2019kapil.9bbfc2b3.jpg";